import { SvrAPk } from "../../utils/axios/index";
/**
 *
 */
export const getPantallaActivos = async () => {
    let res = {};
    try {
      res = await SvrAPk.get("/api/public/screen/getpantallaactivo");
    } catch (Error) {
      res = Error;
    }
    return res;
  };
/**
 *
 **/ 
export const ValidarPantalla = async (PantallaId, CodigoVinc) => {
    let res = {};
    try {
      res = await SvrAPk.post("/api/public/screen/getvalidarpantalla",{PantallaId, CodigoVinc});
    } catch (Error) {
      res = Error;
    }
    return res;
  };
/**
 *
 **/ 
export const getVerficaPantalla = async (PantallaId, ClientAPKey ,CodigoVinc) => {
  let res = {};
  try {
    res = await SvrAPk.post("/api/public/screen/getverificapantalla",{PantallaId, ClientAPKey, CodigoVinc});
  } catch (Error) {
    res = Error;
  }
  return res;
};
